import type { DefaultDividerProps } from './variants/DefaultDivider';
import { DefaultDivider } from './variants/DefaultDivider';
import type { RedSquigglyDividerProps } from './variants/RedSquigglyDivider';
import { RedSquigglyDivider } from './variants/RedSquigglyDivider';

export type DividerProps = DefaultDividerProps | RedSquigglyDividerProps;
export type { DefaultDividerProps } from './variants/DefaultDivider';
export type { RedSquigglyDividerProps } from './variants/RedSquigglyDivider';

function isDefaultVariant(props: DividerProps): props is DefaultDividerProps {
  return !props.variant || props.variant === 'default';
}

/**
 * Add a divider between element to separate list elements or different sections
 * of the page.
 *
 * Use the width prop to increase thickness of divider.
 *
 * @see https://corgi-x.tfd.engineering/components/divider
 */
export function Divider(props: DividerProps) {
  if (isDefaultVariant(props)) {
    return <DefaultDivider {...props} />;
  }
  return <RedSquigglyDivider {...props} />;
}
